import { Link } from 'react-router-dom';
import { FolderIcon } from '@heroicons/react/24/outline';

export function Projects() {
  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Projeler</h1>
          <p>Tüm kullanıcı projelerini yönetmek için admin API henüz hazır değil</p>
        </div>
      </header>

      <div className="admin-card">
        <div className="admin-empty-state">
          <div className="admin-empty-icon" aria-hidden>
            <FolderIcon />
          </div>
          <h2 className="admin-empty-title">Proje listesi yakında</h2>
          <p>
            Sahte örnek veriler kaldırıldı. Admin tarafında tüm film/proje kayıtlarını
            listeleyen bir endpoint eklendiğinde bu ekran gerçek veriyle doldurulacak.
          </p>
          <div className="admin-empty-actions">
            <Link to="/admin" className="admin-btn admin-btn-secondary">
              Kontrole dön
            </Link>
            <Link to="/" className="admin-btn admin-btn-primary">
              Editöre git
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
